<template>
  <picture class="lazy" v-if="imageStyle">
    <source v-for="(imageUrl, key) in imageUrls['sizes']" :key="key"
      :media="'(min-width: ' + key + ')'"
      :data-src="imageUrl"
      />
    <img 
      :src="imageUrls['thumbnail']" 
			:data-src="imageUrls['3000px']"
      :alt="media?.alt.alt"
      :title="media?.title"
       loading="eager" 
    />
  </picture>
</template>

<script lang="ts" setup>
const props = defineProps<{
  media?: Object<{
    id: string
    sourceUrl: {
      path: string
    }
    alt?: {
      alt: string
    }
    title?: string
  }>,
  imageStyle?: string
}>()

const img = useImage()

// Get the data.
const imageUrls = !props?.imageStyle ? props?.media?.sourceUrl?.path :  await useGraphqlQuery('responsiveImageDerivativesById', {
  id: props?.media?.id,
  derivative: props?.imageStyle.toUpperCase(),
  thumbnail: props?.imageStyle.toUpperCase() + '_THUMBNAIL'
}).then((v) => {
  return {
    'sizes': {
      '3000px': img(v?.data?.entityById?.image?.large?.urlPath, {width: 3000, format: 'webp'}),
      '2000px': img(v?.data?.entityById?.image?.large?.urlPath, {width: 3000, format: 'webp'}),
      '1300px': img(v?.data?.entityById?.image?.large?.urlPath, {width: 2000, format: 'webp'}),
      '1000px': img(v?.data?.entityById?.image?.large?.urlPath, {width: 1300, format: 'webp'}),
      '750px': img(v?.data?.entityById?.image?.large?.urlPath, {width: 1000, format: 'webp'}),
      '500px': img(v?.data?.entityById?.image?.large?.urlPath, {width: 750, format: 'webp'}),
      '0px': img(v?.data?.entityById?.image?.large?.urlPath, {width: 500, format: 'webp'}),
    },
    'thumbnail': img(v?.data?.entityById?.image?.thumbnail?.urlPath, {width: 300, format: 'webp'})
  }})
</script>